import { BrandLogo } from '@examflow/ui';
import { BeianFooter } from '../../components/BeianFooter';
import { usePlatformSettings } from './PlatformSettingsContext';

/** Full-screen learner maintenance gate when platform maintenanceMode is on. */
export function MaintenancePage() {
  const { settings } = usePlatformSettings();

  return (
    <div className="flex min-h-dvh flex-col bg-surface-muted">
      <main className="mx-auto flex w-full max-w-lg flex-1 flex-col justify-center px-6 py-16 text-center">
        <div className="mb-6 flex justify-center">
          <BrandLogo variant="full" size={36} alt={settings.siteName || 'ExamFlow'} />
        </div>
        <h1 className="text-2xl font-bold text-ink-primary">平台维护中</h1>
        <p className="mt-3 text-sm leading-6 text-ink-secondary">
          {settings.siteDescription || '我们正在进行系统维护，请稍后再试。'}
        </p>
        {(settings.supportEmail || settings.supportDocsUrl) && (
          <div className="mt-8 space-y-2 text-sm text-ink-secondary">
            {settings.supportEmail ? (
              <p>
                支持邮箱：{' '}
                <a className="text-ink-primary underline" href={`mailto:${settings.supportEmail}`}>
                  {settings.supportEmail}
                </a>
              </p>
            ) : null}
            {settings.supportDocsUrl ? (
              <p>
                <a
                  className="text-ink-primary underline"
                  href={settings.supportDocsUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  查看说明文档
                </a>
              </p>
            ) : null}
          </div>
        )}
      </main>
      <BeianFooter siteName={settings.siteName} />
    </div>
  );
}
